// App.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuestions } from "./store/questionSlice";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import ViewComponent from "./ViewComponent";
import Navigation from "./Navigation";

function App() {
  const dispatch = useDispatch();
  const [currentCount, setCurrentCount] = useState(1); // Initialize with 1 for the first page

  const questions = useSelector((state) => state.questions.questions);
  const loading = useSelector((state) => state.questions.loading);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const passageId = searchParams.get("passage_id");
  const passage = useSelector((state) => state.questions.passage);
   
  useEffect(() => {
    dispatch(fetchQuestions({ passageId }));
  }, []);

  if (loading) {
    // Enhanced loading state
    return (
      <div className="outer-container">
        <div className="loading-container">
          <div className="loader"></div>
          <div className="loading">Loading content...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="outer-container">
      {passage ? (
        <div className="content-container">
          <Routes>
            <Route
              path="/view/:count"
              element={<ViewComponent />}
            />
            <Route
              path="/"
              element={<RedirectToFirstView passageId={passageId} />}
            />
          </Routes>
          <Navigation currentCount={currentCount} setCurrentCount={setCurrentCount} totalPages={questions.total} />
        </div>
      ) : (
        <div className="loading-container">
          <div className="no-passage">No Passage Found</div>
        </div>
      )}
    </div> 
  );
}

function RedirectToFirstView({ passageId }) {
  // Redirect to the first view if passageId is present
  if (passageId) {
    return <Navigate to={`/view/1`} />;
  } else {
    return null; // Render nothing if passageId is not present
  }
}

export default App;
